import { getByClubId } from '@/store/module/team/action/getByClubId.js';
import { getInvitations } from '@/store/module/team/action/getInvitations.js';
import { revokeInvitation } from '@/store/module/team/action/revokeInvitation.js';
import { sendInvitation } from '@/store/module/team/action/sendInvitation.js';

export const actions = {
	getByClubId,
	getInvitations,
	revokeInvitation,
	sendInvitation
};
